// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1KW1C","actionsCol":"EnrolledClinics_actionsCol__3TlXW"};